"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _widths = require("../../../styles/widths");

var Picture = function Picture(_ref) {
  var image = _ref.image,
      image2x = _ref.image2x,
      imageDesktop = _ref.imageDesktop,
      imageDesktop2x = _ref.imageDesktop2x,
      alt = _ref.alt;
  return _react["default"].createElement("picture", null, imageDesktop && imageDesktop2x && _react["default"].createElement("source", {
    media: _widths.imageQueries.desktop,
    srcSet: "".concat(imageDesktop2x, " 2x, ").concat(imageDesktop, " 1x")
  }), image2x && _react["default"].createElement("source", {
    srcSet: "".concat(image2x, " 2x, ").concat(image, " 1x")
  }), _react["default"].createElement("img", {
    src: image,
    alt: alt
  }));
};

Picture.propTypes = {
  image: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string.isRequired,
  image2x: _propTypes["default"].string,
  imageDesktop: _propTypes["default"].string,
  imageDesktop2x: _propTypes["default"].string
};
Picture.defaultProps = {
  image2x: '',
  imageDesktop: '',
  imageDesktop2x: ''
};
var _default = Picture;
exports["default"] = _default;